import _ from 'lodash'
import emojiRegex from 'emoji-regex'
import { ValidateUtil } from '@vzmi/component_ec_nodejs_util'
import { numberNormalizer } from '../components/Proposal/Common/ProposalForm/Shared/normalizers'
import { FIELD_MAX_NUM_VAL } from '@vzmi/shp_shared_compo/constants/proposal'
import { isNumberOrNumberString } from './Validator'
import { pruneEmpty } from './FormHelper'

/**
 *
 * 輸出 Number 或是 ''
 *
 * 如果輸入 isNil 或 ''，輸出 ''
 *
 * 如果輸入 isNumberOrNumberString，輸出 toNumber
 *
 * 如果輸入含數字字串，濾出數字部分，輸出 toNumber
 *
 * 如果輸入不含數字字串，輸出 ''
 * */
export const showOnlyNumber = valueInStore => {
  if (_.isNil(valueInStore) || valueInStore === '') {
    return ''
  }
  if (isNumberOrNumberString(valueInStore)) {
    return _.toNumber(valueInStore)
  }

  const valueToStr = _.toString(valueInStore)
  const trimmedValueStr = ValidateUtil.removeSpaceAndNewline(valueToStr)
  const normalizedValueStr = numberNormalizer(trimmedValueStr)
  return normalizedValueStr === ''
    ? ''
    : _.toNumber(normalizedValueStr)
}

/** 只允許購中店/商城的product id, 即 pXXXX (X=數字) */
export const showOnlyPid = value => {
  if (value === '') {
    return ''
  }
  if (value.match && value.match(/^p\d*$/)) {
    return value
  }
  return ''
}

/** valueInStore 若可以轉為數字並大於 max，則輸出 max */
export const showLessThan = max => valueInStore => {
  if (_.isNil(valueInStore) || valueInStore === '') {
    return ''
  }

  if (isNumberOrNumberString(valueInStore)) {
    const valueToNum = _.toNumber(valueInStore)
    return valueToNum > max ? max : valueToNum
  }

  return valueInStore
}

/** valueInStore 若若可以轉為數字並小於 min，則輸出 min */
export const showNoLessThan = min => valueInStore => {
  if (_.isNil(valueInStore) || valueInStore === '') {
    return ''
  }

  if (isNumberOrNumberString(valueInStore)) {
    const valueToNum = _.toNumber(valueInStore)
    return valueToNum < min ? min : valueToNum
  }

  return valueInStore
}

/** 輸出濾掉 emoji 的字串 */
export const showNoEmoji = valueInStore => {
  const regex = emojiRegex()
  return _.toString(valueInStore).replace(regex, '')
}

/** 超過 FIELD_MAX_NUM_VAL.NOT_SPECIFIED 限制的數會被轉成最大值 */
export const showUnderInputNumberLimit = valueInStore => {
  return showLessThan(FIELD_MAX_NUM_VAL.NOT_SPECIFIED)(valueInStore)
}

/** 只輸出可以轉為數字並 > 0 的值，其他都阻擋 */
export const showOnlyPositiveNumber = valueInStore => {
  return _.toNumber(valueInStore) > 0
    ? valueInStore
    : ''
}

/** 只輸出可以轉為數字並四捨五入的值，其他都阻擋 */
export const showRoundedNumber = valueInStore => {
  return isNumberOrNumberString(valueInStore)
    ? Math.round(_.toNumber(valueInStore))
    : ''
}

export const formatAll = (...formatters) =>
  value => _.flow(formatters)(value)

export const zeroOrNegativeFormatTo = num => valueInStore => {
  if (valueInStore === '') { return '' }
  const isUnderOrEqualZero = _.toNumber(valueInStore) <= 0
  return isUnderOrEqualZero ? num : valueInStore
}

/** 只顯示小於 InputNumber 最大值限制的正整數 (0 不顯示) */
export const showOnlyPositiveInteger = formatAll(
  showOnlyNumber,
  showOnlyPositiveNumber,
  showRoundedNumber,
  showUnderInputNumberLimit
)

/** 只顯示合法的長寬高 */
export const showValidSizeDimension = formatAll(
  showOnlyPositiveInteger,
  showLessThan(FIELD_MAX_NUM_VAL.SIZE_DIMENSION)
)

/** 只顯示合法的商品重量 */
export const showValidWeight = formatAll(
  showOnlyNumber,
  showOnlyPositiveNumber,
  showRoundedNumber,
  showLessThan(FIELD_MAX_NUM_VAL.WEIGHT)
)

/** 只顯示合法的保存期限 */
export const showValidPreserveDays = formatAll(
  showOnlyNumber
)

export const showUniqNumberId = (value = []) => {
  const onlyNumberValues = value.map(v => showOnlyNumber(v))
  const uniqueValues = Array.from(new Set(pruneEmpty(onlyNumberValues)))
  return uniqueValues
}
